module.exports = __webpack_public_path__ + "img/_54A6745_t.f2281a26.jpg";